module.exports = __webpack_public_path__ + "img/sbl0008.774b2588.png";